/** LaunchDarkly feature flag keys used across the Model Builder application. */
export const FEATURE_FLAGS = {
  MODEL_BUILDER: 'umm-model-builder',
  MODEL_BUILDER_MODEL_VIEWER: 'umm-mb-model-viewer',
  MODEL_BUILDER_MODEL_VIEWER_DEVELOPER_TOOLS: 'model-builder-model-viewer-developer-tools',
  SEED_MODEL_ID: 'umm-mb-seed-model-id',
  ENABLE_INLINE_BYTES: 'umm-mb-enable-inline-bytes',
} as const;
